/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Packaging_Deducted_DescInputs */

const vi_order_packaging_deducted_desc = /** @type {(inputs: Order_Packaging_Deducted_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vật tư bao bì đã trừ theo đơn ở bước xác nhận. Khi huỷ hoặc hoàn đơn, các lô này sẽ được nhập lại theo lựa chọn.`)
};

/**

* @param {Order_Packaging_Deducted_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_packaging_deducted_desc = /** @type {((inputs?: Order_Packaging_Deducted_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Packaging_Deducted_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_packaging_deducted_desc(inputs)
});